export const calculateReservationTotal = (
    {
        offer,
        promotionPreview,
        selectedInsurance,
        selectedParkingOffer,
        userData,
        useCashbackForPay,
    },
    includeCashbackDiscount = false,
) => {
    try {
        if (!offer || !offer.price) {
            return '-'
        }

        const baseTripAmount = Number(offer.price) / 100

        const tripAmountAfterPromotions = promotionPreview
            ? Number(promotionPreview.tripAmountAfterGiftVouchers)
            : baseTripAmount

        const insuranceAmount = Number(
            selectedInsurance && selectedInsurance.totalPrice
                ? selectedInsurance.totalPrice
                : 0,
        )

        const parkingAmount = Number(
            selectedParkingOffer && selectedParkingOffer.price_online
                ? selectedParkingOffer.price_online
                : 0,
        )

        const amountBeforeCashback = Number(
            (tripAmountAfterPromotions || 0) +
            insuranceAmount +
            parkingAmount,
        )

        const cashbackBalance = Number(
            userData && userData.cashbackBalance
                ? userData.cashbackBalance
                : 0,
        )

        const cashbackAmount =
            includeCashbackDiscount &&
            useCashbackForPay &&
            cashbackBalance > 0
                ? Math.min(cashbackBalance, amountBeforeCashback)
                : 0

        return Number(amountBeforeCashback - cashbackAmount).toFixed(2)
    } catch (error) {
        return '-'
    }
}
